export default "__VITE_ASSET__Bi7yQRiI__"